// extracted by mini-css-extract-plugin
export default {"container":"Ap-z","heading":"Bp-z","text":"Cp-z","info":"Dp-z","link":"Ep-z","fullMaxWidth":"Fp-z"};